module.exports = __webpack_public_path__ + "static/media/Grandma Visitor.e9b1bfde.jpg";